import { render } from "./HomeViewProfessor.vue?vue&type=template&id=653ec0d5&scoped=true"
import script from "./HomeViewProfessor.vue?vue&type=script&lang=js"
export * from "./HomeViewProfessor.vue?vue&type=script&lang=js"

import "./HomeViewProfessor.vue?vue&type=style&index=0&id=653ec0d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653ec0d5"]])

export default __exports__